import _ from 'underscore';

/**
 * whether a user can use fastrecruit, based on token scope and presence of an account
 * @param token
 * returns {Boolean}
 */
export function canUseFastRecruit(token) {
  const { scopes, userDetails: { accounts, superAdmin } } = token;
  const hasFastRecruitScope = scopes && _.contains(scopes, 'fastrecruit');
  const hasOneAccount = (accounts && accounts.length > 0);

  return Boolean((hasOneAccount || superAdmin) && hasFastRecruitScope);
}


// WEBPACK FOOTER //
// ./src/js/util/TokenUtil.js